






































































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import ApplicationForm from './ApplicationForm.vue'
import SparepartsTable from './SparepartsTable.vue'
import MaintenanceTable from './MaintenanceTable.vue'
import { MaintainItemServiceProxy, MaintainPlanServiceProxy, MaintainRecordServiceProxy } from "@/service-proxies/app-v2/tpm.service-proxies";
import { MaterialServiceProxy } from "@/service-proxies/app-v2/material.service-proxies";
import dayjs from "dayjs";

const mpsp = new MaintainPlanServiceProxy()
const misp = new MaintainItemServiceProxy()
const mrsp = new MaintainRecordServiceProxy()
const msp = new MaterialServiceProxy()

export default Vue.extend({
  data(){
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      form: this.$form.createForm(this),
      loading: false,
      selectedData: {},
      selectPlanCode: "",
      maintainPlanItemVoList: [],
      maintainItemList: [],
      changeMaintenanceList: [],
      maintenanceList: [],
      changeSparepartsList: [],
      editDataForm1: {},
      maintainPlanList: []
    }
  },
  components:{
    ApplicationForm,
    SparepartsTable,
    MaintenanceTable
  },
  props:{
    visible:{
      type: Boolean,
      default: false
    },
    employeesList:{
      type: Array,
      default: () => ([])
    },
    data:{
      type: Object,
      default: () => ({})
    },
  },
  watch:{
    visible: {
      handler(){
        if(this.visible) {
          misp.queryMaintainItemList("").then(res =>{
            this.maintainItemList = res
          })
          this.handleChange()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods:{
    handleChange() {
      mpsp.getMaintainPlan(this.data.planId).then(res =>{
        res.maintainPlanItemVoList.forEach((item,index) =>{
          const data = {
            key: index,
            id: item.itemId,
            code: item.itemCode,
            name: item.itemName,
            remark: item.itemRemark,
            requirement: item.itemRequirement,
            isExecute: true
          }
          this.maintenanceList.push(data)
        })
      })
      this.changeMaintenanceList = JSON.parse(JSON.stringify(this.data.maintainRecordItemVoList))
      this.changeMaintenanceList.forEach((item,index) =>{
         item.key = index
      })
      this.changeSparepartsList = JSON.parse(JSON.stringify(this.data.repairRecordMaterialVOList))
      this.changeSparepartsList.forEach((item,index) =>{
         item.key = index
      })
      this.selectedData = this.data
      this.editDataForm1 = this.data
    },
    changeCode(value){
      this.selectPlanCode = value.target.value
    },
    close(){
      this.form.resetFields()
      this.$refs.form1.form.resetFields()
      this.changeMaintenanceList = []
      this.changeSparepartsList = []
      this.selectedData = {}
      this.editDataForm1 = {}
      this.$emit('close')
    },
    changeMaintenance(value){
      this.changeMaintenanceList = value
    },
    changeSpareparts(value){
      this.changeSparepartsList = value
    },
    reset(){
      this.form.resetFields()
      this.$refs.form1.form.resetFields()
      this.changeMaintenanceList = []
      // this.maintenanceList = []
      this.changeSparepartsList = []
      this.selectedData = {}
      this.editDataForm1 = {}
      this.changeMaintenanceList = JSON.parse(JSON.stringify(this.data.maintainRecordItemVoList))
      this.changeMaintenanceList.forEach((item,index) =>{
         item.key = index
      })
      this.changeSparepartsList = JSON.parse(JSON.stringify(this.data.repairRecordMaterialVOList))
      this.changeSparepartsList.forEach((item,index) =>{
         item.key = index
      })
      this.selectedData = this.data
      this.editDataForm1 = this.data
    },
    save(){
      this.form.validateFields((err,valued) => {
        if(!err){
          this.$refs.form1.form.validateFields((err,values) => {
            if(!err){
              if(this.changeSparepartsList && this.changeSparepartsList.length){
                let hasNum = true
                this.changeSparepartsList.forEach(element => {
                  if(element.stockOutNum == null || element.stockOutNum == 0){
                    hasNum = false
                  }
                });
                if(!hasNum){
                  this.$message.warning('请输入备品备件数量')
                  return
                }
              }
              values.id = this.data.id
              values.recordCode = this.data.recordCode
              values.planId = this.data.planId
              values.startTime = values.startTime ? dayjs(values.startTime).format('YYYY-MM-DD HH:mm:ss') : values.startTime
              values.endTime = values.endTime ? dayjs(values.endTime).format('YYYY-MM-DD HH:mm:ss') : values.endTime
              this.changeMaintenanceList.forEach(element => {
                element.isExecute = (element.isExecute ? 1: 0)
              });
              values.maintainRecordItemAddDTOList = this.changeMaintenanceList
              values.repairRecordMaterialAddDTOList = this.changeSparepartsList
              const person = this.employeesList.find(res => res.id === values.maintainUserId)
              if(person !== undefined) {
                values.maintainUserName = person.name
              }
              mrsp.editMaintainRecord(values).then(() => {
                this.$message.success(this.$t('page_mdc_setting_edit_success'))
                this.form.resetFields()
                this.$refs.form1.form.resetFields()
                this.changeMaintenanceList = []
                this.changeSparepartsList = []
                this.selectedData = {}
                this.editDataForm1 = {}
                this.$emit('reload')
              })
            }
          })
        }
      })
    }
  }
})

